import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'marketingPlanMenu',
    standalone: false
})
export class MarketingPlanMenuPipe implements PipeTransform {
  transform(
    value: any,
    locked: boolean,
    optionClicked: string,
    deleteText: string,
    isDeleteDisabled: boolean,
  ): any {
    if (locked) {
      return true;
    }
    return optionClicked === deleteText && isDeleteDisabled;
  }
}
